import { render, staticRenderFns } from "./PriceField.vue?vue&type=template&id=172ea498&scoped=true&"
import script from "./PriceField.vue?vue&type=script&lang=js&"
export * from "./PriceField.vue?vue&type=script&lang=js&"
import style0 from "./PriceField.vue?vue&type=style&index=0&id=172ea498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172ea498",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSheet,VTextField})
